import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'app-popup-alerts',
    templateUrl: './popup-alerts.component.html',
    styleUrls: ['./popup-alerts.component.scss'],
    standalone: false
})
export class PopupAlertsComponent {

  constructor(public dialogRef: MatDialogRef<PopupAlertsComponent>,
              private router: Router) {
  }

  editAlert() {
    this.dialogRef.close();
    this.router.navigate(['/manageAlerts/edit/' + this.dialogRef.id + '/edit']);
  }

}
